import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import type { Tables } from "@msuite/utils/types";
import { client } from "@/hono";
import { columns } from "./table-config";
import { WorkspacesMenu } from "./workspaces-menu";

export function OrganizationSettingsWorkspaces() {
	/** Hooks */

	/** Query */
	const {
		data: workspaces,
		queryKey,
		refetch,
		isLoading,
	} = useQuery({
		queryKey: ["workspaces"],
		queryFn: async () => {
			const response = await client.organizations.workspaces.$get();
			const data = await responseHandler(response as any);
			return data.workspaces as Tables<"workspaces">[];
		},
	});

	/** Render */
	return (
		<DataTable
			data={workspaces ?? []}
			columns={columns}
			isLoading={isLoading}
			queryKey={queryKey}
			menu={<WorkspacesMenu queryKey={queryKey} />}
			persistenceKey="organization-settings-workspaces-table"
			refetch={refetch}
		/>
	);
}
